import PropTypes from "prop-types";
import React, { useEffect, useState } from "react";
import AdminPageLayout from "../../../../components/FullPageLayout/AdminPageLayout";
import { useDispatch } from "react-redux";
import { push } from "connected-react-router";
import {
  buildPolicyVersionDetailsRoute,
  buildPolicyDetailsVersionsRoute,
  policyVersionDetails,
  policyVersion
} from "../../../../routes/AdminRoutes";
import { Route, Redirect } from "react-router-dom";
import { useTranslation } from "react-i18next";
import PolicyVersionDetails from "./PolicyVersionDetails";
import Breadcrumb from "../../../../components/Breadcrumb/Breadcrumb";
import LoadingSpinner from "../../../../components/LoadingSpinner/LoadingSpinner";
import usePolicies from "../../../../hooks/policies";

const PolicyVersionTitle = ({ courseName, releaseVersion }) => {
  return (
    <Breadcrumb
      routes={["Policies", courseName, `Manage Version ${releaseVersion}`]}
    />
  );
};

const PolicyVersion = ({
  location: { pathname },
  match: {
    params: { policyId, versionId }
  }
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const [versionData, setVersionData] = useState();

  const { fetchPolicyVersion } = usePolicies();

  const releaseVersionName = () => {
    if (!versionData) return "";

    if (versionData.pending) {
      return t("courseVersion.details.pendingRelease", {
        releaseVersion: versionData.release
      });
    } else {
      return versionData.release;
    }
  };

  const setVersionDataState = data => {
    setVersionData(data);
  };

  useEffect(() => {
    const loadPolicyVersion = async () => {
      const data = await fetchPolicyVersion(policyId, versionId);
      setVersionDataState(data);
    };
    loadPolicyVersion();
  }, [policyId, versionId]);

  const handleGoBackToPolicyVersionsView = () => {
    dispatch(push(buildPolicyDetailsVersionsRoute(policyId)));
  };

  return (
    <AdminPageLayout
      title={
        <PolicyVersionTitle
          courseName={versionData ? versionData.name : ""}
          releaseVersion={releaseVersionName()}
        />
      }
      onGoBackClick={handleGoBackToPolicyVersionsView}
    >
      {versionData ? (
        <>
          <Route
            exact
            path={policyVersion}
            render={() => (
              <Redirect
                to={buildPolicyVersionDetailsRoute(policyId, versionId)}
              />
            )}
          />
          <Route
            exact
            path={policyVersionDetails}
            render={props => (
              <PolicyVersionDetails
                {...props}
                versionData={versionData}
                setVersionDataState={data => setVersionDataState(data)}
              />
            )}
          />
        </>
      ) : (
        <LoadingSpinner />
      )}
    </AdminPageLayout>
  );
};

PolicyVersion.propTypes = {
  match: PropTypes.shape({
    params: PropTypes.shape({
      policyId: PropTypes.string
    }),
    path: PropTypes.string,
    url: PropTypes.string
  }),
  location: PropTypes.shape({
    pathname: PropTypes.string
  })
};

export default PolicyVersion;
